import {
    GDPR_LOG_SET_RESPONSIBILITY_START,
    GDPR_LOG_SET_RESPONSIBILITY_ERROR,
    GDPR_LOG_SET_RESPONSIBILITY_SUCCESS,
    GDPR_LOG_GET_RESPONSIBILITY_START,
    GDPR_LOG_GET_RESPONSIBILITY_ERROR,
    GDPR_LOG_GET_RESPONSIBILITY_SUCCESS
} from "../../actions/services/gdprlog";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export default function gdprlog(state = defaultState, { type, payload, error }) {
    switch (type) {
        case GDPR_LOG_SET_RESPONSIBILITY_START:
        case GDPR_LOG_GET_RESPONSIBILITY_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case GDPR_LOG_SET_RESPONSIBILITY_SUCCESS:
        case GDPR_LOG_GET_RESPONSIBILITY_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                config: payload
            };
        case GDPR_LOG_SET_RESPONSIBILITY_ERROR:
        case GDPR_LOG_GET_RESPONSIBILITY_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        default:
            return state;
    }
}
